import { plazaGraphsActionTypes } from '../../../../../common/constants/plaza/graphs/store/constants';

export const prefix = 'PLAZA_REPORT_';

export const ACTION_TYPES = plazaGraphsActionTypes(prefix);
